class GROWQuiz {

	constructor() { 
		this.questions = []
		this.step = 1
		this.answerGood = ''
		this.answerNegative = ''
		this.questionTemplate = null
		this.answerBG = ''
		this.questionBG = ''
		this.textColor = ''
		this.result = false
		this.language = "de"
	}

	init(opt) { 
		this.answerGood = opt.answerGood;
		this.answerNegative = opt.answerNegative;
		this.textColor = opt.fontColor;
		this.questionBG = opt.bgColor;
		this.answerBG = opt.resultBg;
		opt.questions.map(q => { 
			this.questions.push(this.splitAnswer(q));
		})
	}

	start(opt, element) {
		this.language = opt.language
		this.quizContainer = document.querySelector(element);
		this.questionTemplate = document.querySelector('#question__template');
		this.init(opt)
		this.renderQuestion(this.step - 1)
	}
	splitAnswer(a) { 
		const answer = a.split('[')
		answer[1] = answer[1].replace(']', '')
		const response = {question: answer[0], answer: answer[1]}
		return response
	}

	removeQuestion(el) {
		this.quizContainer.innerHTML = '';
	 }
	renderQuestion(step) {

		const template = this.questionTemplate.content.cloneNode(true);
		const quizWrapper = template.querySelector('.quiz__wrapper');
		const quizText = template.querySelector('.question__text');
		const buttonContainer = template.querySelector('.submit__buttons');
		quizWrapper.style.color = this.textColor;


		console.log(this.questions)

		if (this.step - 1 < this.questions.length) {
			// Fragen zeigen
			const nextText = this.questions[this.step - 1].answer;
			const buttonYes = document.createElement('div');
			const buttonNo = document.createElement('div');
			buttonYes.classList.add('main__button', 'button__small');
			buttonNo.classList.add('main__button', 'button__small');

			const trueEvent = () => {
				this.step++
				this.result = true
				this.removeQuestion(template)
				this.renderQuestion(this.step - 1)
				console.log('true', this.step)
			}
			
			const falseEvent = () => { 

				this.step = this.questions.length + 1
				this.result = false
				this.removeQuestion(template)
				this.renderQuestion(this.step)
				console.log('false', this.step)
			}

			const yesText = this.language === "de" ? "Ja" : "Yes";
			const noText = this.language === "de" ? "Nein" : "No";

			buttonYes.addEventListener('click', nextText === "true" ? trueEvent : falseEvent)
			buttonNo.addEventListener('click', nextText === "false" ? trueEvent : falseEvent)

			buttonYes.innerHTML = yesText;
			buttonYes.setAttribute('data-answer', 'true')
			buttonNo.innerHTML = noText;
			buttonNo.setAttribute('data-answer', 'false')

			buttonContainer.appendChild(buttonYes);
			buttonContainer.appendChild(buttonNo);

			quizWrapper.style.backgroundColor = this.questionBG;
			quizText.innerHTML = this.questions[this.step - 1].question;
		} else { 
			quizWrapper.style.backgroundColor = this.answerBG;
			quizText.innerHTML = this.result ? this.answerGood : this.answerNegative;
		}
	
		this.quizContainer.appendChild(template);

	}
}

const GrowQuiz = new GROWQuiz();